import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sms-code',
  templateUrl: './sms-code.component.html',
  styleUrls: ['./sms-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsCodeComponent implements AfterViewInit {
  @ViewChild('codeInput', { static: false }) codeInput: ElementRef<HTMLInputElement>;

  @Output()
  public enterCode: EventEmitter<string> = new EventEmitter();
  private readonly codeLength = 4;

  ngAfterViewInit() {
    this.codeInput?.nativeElement?.focus();
  }

  public onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = (input.value || '').replace(/\D/g, '').slice(0, this.codeLength);
    input.value = digits;
    if (digits.length === this.codeLength) {
      // Let go of focus once the code is complete. Left focused, the input
      // swallows the customer's next tap on the page (e.g. a tip button): that
      // tap only blurs it, so "No tip" looks broken until tapped twice.
      input.blur();
      this.enterCode.emit(digits);
    }
  }
}
